import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, IconButton, TextField } from '@mui/material';
import * as React from 'react';
import Time from './component/time';
import { HelperText } from './helper-text';

interface TimeInputProps {
    label: string
    value: string
    startHour: string
    endHour: string
    onChange?: (value: string) => void;
    onClear?: (e: any) => void
    disabled?: boolean
    width?: number
    helperText?: string
    fullWidth?: boolean
    required?: boolean
    marginBottomErrorText?: string
}

export default function TimeInput(props: TimeInputProps) {

    const [open, setOpen] = React.useState(false)
    const timeRef = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (timeRef.current && !timeRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [timeRef]);

    function formatTime(timeString: string) {
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(parseInt(hours, 10));
        date.setMinutes(parseInt(minutes, 10));

        const options: any = { hour: '2-digit', minute: '2-digit', hour12: false };
        const formattedTime = date.toLocaleTimeString('th-TH', options);

        if (timeString) {
            return `${formattedTime}`;
        }
    }

    return (
        <Box position='relative'>
            <TextField
                value={formatTime(props.value) || ''}
                onClick={() => setOpen(!open)}
                label={props.label}
                helperText={props.helperText ? <HelperText label={props.helperText} /> : ''}
                error={props.helperText !== '' && props.helperText !== undefined}
                disabled={props.disabled}
                required={props.required}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <>
                            {props.value && !props.disabled && <IconButton onClick={(e) => {
                                e.stopPropagation(); // ✅ ป้องกันการเปิด calendar
                                props.onClear?.(e);
                            }}>
                                {props.onClear && <ClearIcon />}
                            </IconButton>}
                            <IconButton sx={{ width: '24px', height: '24px' }}>
                                <AccessTimeIcon sx={{ color: props.disabled ? '#BBBBBB' : '#1CB99A' }} />
                            </IconButton>
                            {/* {props.value && <IconButton onClick={props.onClear}>
                                <ClearIcon />
                            </IconButton>}
                            {!props.disabled && <IconButton sx={{ width: '24px', height: '24px' }}>
                                <AccessTimeIcon sx={{ color: props.disabled ? '#BBBBBB' : '#1CB99A' }} />
                            </IconButton>} */}
                        </>
                    )
                }}
                sx={{
                    width: props.width,
                    '& .MuiInputBase-root': {
                        flexDirection: 'row',
                        alignItems: 'center',
                    },
                    '& .MuiInputLabel-root': {
                        transform: 'translate(14px, 9px)',
                        color: open ? '#1CB99A' : '#808080'
                    },
                    '& .MuiInputLabel-shrink': {
                        transform: 'translate(14px, -10px) scale(0.75)',
                    },
                    '& .MuiOutlinedInput-root': {
                        height: '40px',
                        alignItems: 'center',
                        backgroundColor: props.disabled ? '#F0F0F0' : '#FFFFFF',
                        '& fieldset': {
                            borderColor: open ? '#1CB99A' : '#C5C5C5',
                        },
                        '&:hover fieldset': {
                            borderColor: open ? '#1CB99A' : '#231F20',
                            color: '#29302E'
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#1CB99A',
                            color: '#29302E'
                        },
                        '&.Mui-disabled fieldset': {
                            borderColor: '#C5C5C5',
                        },
                        '&.Mui-error fieldset': {
                            borderColor: `#B00020`,
                        },
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: '#1CB99A',
                    },
                    '& .MuiInputLabel-root.Mui-error': {
                        color: '#B00020'
                    },
                    '& .MuiOutlinedInput-input': {
                        '& .Mui-disabled': {
                            color: '#808080'
                        }
                    },
                    '& .MuiFormHelperText-root': {
                        marginLeft: 0,
                        marginTop: 0,
                        marginBottom: props.marginBottomErrorText || '8px',
                    },
                }}
                fullWidth={props.fullWidth}
                InputLabelProps={{
                    sx: {
                        '& .MuiFormLabel-asterisk': {
                            color: (!props.value || props.value === '') ? 'gray !important' : "red !important", // สีเทาเมื่อไม่ได้โฟกัส
                        },
                        '&.Mui-focused .MuiFormLabel-asterisk': {
                            color: 'red !important', // สีแดงเมื่อโฟกัส
                        },
                    },
                }}
            />
            {open && (
                <Box ref={timeRef} width={148} zIndex={50} position='absolute' >
                    <Time value={props.value} startHour={props.startHour} endHour={props.endHour} onChange={props.onChange} />
                </Box>
            )}
        </Box>
    );
}